import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Dna, BookOpen, HeartPulse } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-holistic-sage text-white relative overflow-hidden" data-id="element-157">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-158"></div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-159">
        <div className="text-center mb-16" data-id="element-160">
          <FadeIn data-id="element-161">
            <h2 className="text-4xl md:text-5xl font-serif mb-6 text-holistic-cream" data-id="element-162">
              La farmacia está en tu ADN
            </h2>
            <p className="text-xl text-holistic-sand/90 max-w-2xl mx-auto" data-id="element-163">
              Cuando aprendes a descodificar el mensaje oculto detrás de cada
              síntoma, la sanación deja de ser un milagro para convertirse en
              una consecuencia biológica.
            </p>
          </FadeIn>
        </div>

        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/20 shadow-2xl" data-id="element-164">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-165">
            <FadeIn direction="right" data-id="element-166">
              <div className="space-y-6" data-id="element-167">
                <div className="inline-block bg-holistic-gold px-4 py-1.5 rounded-full text-sm font-bold tracking-wide uppercase" data-id="element-168">
                  Presentamos
                </div>
                <h3 className="text-3xl md:text-4xl font-serif text-holistic-cream" data-id="element-169">
                  Código de Autocuración
                  <br data-id="element-170" />
                  <span className="text-holistic-gold-light" data-id="element-171">
                    + Recetas Sanadoras
                  </span>
                </h3>
                <p className="text-lg text-holistic-sand/90 leading-relaxed" data-id="element-172">
                  Un protocolo 100% digital diseñado para que tomes las riendas
                  de tu salud y aprendas a liberar los bloqueos que te enferman.
                </p>
                <ul className="space-y-4 pt-4" data-id="element-173">
                  {[{
                  icon: <Dna size={20} data-id="element-174" />,
                  text: 'Basado en Biodecodificación'
                }, {
                  icon: <BookOpen size={20} data-id="element-175" />,
                  text: 'Material 100% Digital y Práctico'
                }, {
                  icon: <HeartPulse size={20} data-id="element-176" />,
                  text: 'Resultados desde la primera semana'
                }].map((item, i) => <li key={i} className="flex items-center gap-3 text-holistic-cream" data-id="element-177">
                      <span className="bg-white/20 p-2 rounded-full" data-id="element-178">
                        {item.icon}
                      </span>
                      <span className="font-medium" data-id="element-179">{item.text}</span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>

            <FadeIn direction="left" delay={0.2} data-id="element-180">
              <div className="relative aspect-square max-w-sm mx-auto" data-id="element-181">
                <div className="absolute inset-0 bg-holistic-gold/20 rounded-full blur-3xl" data-id="element-182"></div>
                <img src="https://cdn.magicpatterns.com/uploads/uJsaGzaNqPjF7ZwWjdZi9X/ChatGPT_Image_8_jun_2026,_14_49_23.png" alt="Cuerpo humano con red de energía luminosa fluyendo" className="relative z-10 w-full h-full object-cover rounded-2xl shadow-2xl border-4 border-white/10" data-id="element-183" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}